import 'angular';

import {
  downgradeComponent,
  downgradeInjectable
} from '@angular/upgrade/static';

import { QuotesAcceptedQuotesComponent } from './quotes.accepted-quotes.component';
import { QuotesService }                 from './quotes.service';

angular.module('app-lite.quotes', [])
  .directive('worAcceptedQuotes', downgradeComponent({ component: QuotesAcceptedQuotesComponent }))
  .service('quotesApi', downgradeInjectable( QuotesService ));
